import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';
import { GET_CLIENTS_FOR_SELECTOR } from '../../../common/graphql/client';


const ClientSelector = (props) => {

	const { query } = props;

	return (
		<SearchDropdownSelector
			query={query || GET_CLIENTS_FOR_SELECTOR}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select Client"
			{...props}
		/>
	);
};

export default ClientSelector;
